import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'EasyHome 3D';
  public isLoggedIn: boolean = true;

  constructor(private router: Router, public translate: TranslateService) {
    // Ajout des langues supportées
    translate.addLangs(['fr', 'en']);
    
    // Récupération de la langue du navigateur
    const browserLang = translate.getBrowserLang();
    
    // Définition de la langue par défaut
    translate.setDefaultLang('fr');
    
    // Utilisation de la langue du navigateur si elle est supportée, sinon français
    translate.use(browserLang?.match(/fr|en/) ? browserLang : 'fr');
  }

  switchLanguage(lang: string) {
    this.translate.use(lang);
  }

  affiche(): boolean {
  var splitted = this.router.url.split("/", 3); 
    return !((splitted[1] === 'properties')||(splitted[1] === 'research')||(splitted[1] === 'search'));
  }
}
